// Mounted once at the app root: turns the Live sample's refused writes into
// one friendly toast (PRD 117, D4). Renders nothing, and outside demo mode
// never hears anything, because apiFetch only reports refusals in demo mode.
//
// The toast carries no "Start your books" action because ToastContext has no
// actions; the banner above every screen carries that link.

import { useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import { subscribeDemoReadOnly } from '../../services/demoReadOnlyNotifier';
import { DEMO_READ_ONLY_TOAST, getDemoSession } from '../../config/demo';
import { capture } from '../../analytics/posthog';
import { EVENTS } from '../../analytics/events';

export const DemoReadOnlyListener: React.FC = () => {
  const { showInfo } = useToast();

  useEffect(
    () =>
      subscribeDemoReadOnly(() => {
        showInfo(DEMO_READ_ONLY_TOAST);
        capture(EVENTS.DEMO_READ_ONLY_HIT, { demo_persona: getDemoSession()?.persona });
      }),
    [showInfo]
  );

  return null;
};

export default DemoReadOnlyListener;
